var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 600,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 100 30L0 60z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 50 30L0 60z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2A936A",
    d: "M0 0h100v60H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC20E",
    stroke: "#fff",
    strokeWidth: 4,
    d: "m0 0 100 30L0 60",
    clipPath: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE1E2D",
    stroke: "#000",
    strokeWidth: 4,
    d: "m0 0 50 30L0 60",
    clipPath: "url(#b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGy);
export default __webpack_public_path__ + "static/media/gy.70721e7627eab306fa9617bd80a4cc0e.svg";
export { ForwardRef as ReactComponent };